import { useEffect, useState } from "react";
import axios from "axios";

export const VerificationImage = ({ label, kind, url, token }) => {
  const [image, setImage] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    setImage(null); setError("");
    if (!url) return;
    let objectUrl;
    const controller = new AbortController();
    axios.get(`${process.env.REACT_APP_BACKEND_URL}${url}`, {
      headers: { Authorization: `Bearer ${token}` }, responseType: "blob", signal: controller.signal,
    }).then(({ data }) => {
      if (controller.signal.aborted) return;
      objectUrl = URL.createObjectURL(data);
      setImage({ url, src: objectUrl });
    }).catch((e) => {
      if (!controller.signal.aborted) setError(e.response?.status === 410 ? "Document deleted" : "Document unavailable");
    });
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [url, token]);
  return <figure className="min-w-0">
    <figcaption className="text-xs text-[#8A92A0] mb-1" data-testid={`verif-file-label-${kind}`}>{label}</figcaption>
    <div className="rounded-lg border border-[#1A2030] bg-black aspect-square overflow-hidden flex items-center justify-center">
      {image?.url === url && image?.src
        ? <img data-testid={`verif-file-${kind}`} src={image.src} alt={label} className="w-full h-full object-contain" />
        : <p data-testid={`verif-file-state-${kind}`} className="text-[10px] text-[#8A92A0] text-center px-1">{error || (url ? "Loading…" : "Not provided")}</p>}
    </div>
  </figure>;
};